import ResponsiveStyleSheet from "react-native-media-query";
import { theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: {
    marginTop: theme.spacing.small,
    paddingVertical: theme.spacing.xsmall,
    paddingHorizontal: theme.spacing.small,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: theme.spacing.xsmall2,
  },
  removeCoupon: {
    borderRadius: theme.spacing.xlarge,
    padding: theme.spacing.xsmall2,
    backgroundColor: theme.colors.negative.base,
  },
});
